import { ValidatorResult } from '@unitedtraders/validators';
import { isValid, parse } from 'date-fns';
import { Money } from '../types/gql';

// t('validator:not enough balance')
export const inBalance =
  (balance: Money) =>
  (value: string): ValidatorResult =>
    value && +value > balance.value
      ? {
          key: 'validator:not enough balance',
          options: { balance },
        }
      : false;

export const validAccountNumber =
  (key: string) =>
  (value: string): ValidatorResult =>
    value && !/\d{20}/.test(value?.replace(/[^\d]/g, '')) ? { key, options: {} } : false;

const checkCardNumber = (value: string) =>
  value
    .split('')
    .reverse()
    .map((symbol, i) => parseInt(symbol, 10) * (i % 2 ? 2 : 1))
    .reduce((sum, digit) => sum + (digit > 9 ? digit - 9 : digit)) %
    10 ===
  0;

// t('validator:incorrect card number')
export const validCardNumber =
  () =>
  (value: string): ValidatorResult => {
    const result = value?.replace(/[^\d]/g, '');
    return value && (result.length < 14 || result.length > 18 || !checkCardNumber(result))
      ? { key: 'validator:incorrect card number', options: {} }
      : false;
  };

// t('validator:must be multiple of {{factor}}')
export const isMultiple =
  (factor: number) =>
  (value: string): ValidatorResult =>
    value && +value % factor !== 0
      ? { key: 'validator:must be multiple of {{factor}}', options: { factor } }
      : false;

// t('validator:date')
export const date =
  (message?: string) =>
  (value: string): ValidatorResult =>
    value && !isValid(parse(value, 'dd.MM.yyyy', new Date()))
      ? {
          key: message || 'validator:date',
          options: {},
        }
      : false;
